export default {
  id : 'moldHalf.PlyLayerShopFloor',
  name : 'moldHalf.PlyLayerShopFloor',
  displayName : 'Quality',
  objectType : 'moldHalf',
  valueType : 'string',
  get : ( obj ) => {
    return obj.id
  }
}
